(() => {
  'use strict';

  const cardSelector = '[data-rp-card-carousel]';
  const mobileQuery = window.matchMedia('(max-width: 767px)');

  function ensureSlide(slide) {
    if (!slide || !slide.dataset.rpBgset) return;
    slide.setAttribute('data-bgset', slide.dataset.rpBgset);
    delete slide.dataset.rpBgset;
    slide.classList.add('lazyload');
    if (window.lazySizes && window.lazySizes.loader) {
      window.lazySizes.loader.unveil(slide);
    }
  }

  function positionTrack(card, index, offset = 0, animate = true) {
    const track = card.querySelector('.rp-card-mobile-carousel');
    if (!track) return;
    track.classList.toggle('rp-dragging', !animate);
    track.style.transform =
      `translate3d(calc(${-index * 100}% + ${offset}px), 0, 0)`;
  }

  function setIndex(card, requested) {
    if (!mobileQuery.matches) return;
    const slides = [...card.querySelectorAll('[data-rp-slide]')];
    if (!slides.length) return;

    const index = Math.max(0, Math.min(requested, slides.length - 1));
    card.dataset.rpIndex = String(index);
    ensureSlide(slides[index]);
    positionTrack(card, index);

    slides.forEach((slide, position) => {
      const active = position === index;
      slide.classList.toggle('rp-active', active);
      slide.setAttribute('aria-hidden', active ? 'false' : 'true');
    });

    card.querySelectorAll('[data-rp-go]').forEach((dot, position) => {
      const active = position === index;
      dot.classList.toggle('rp-active', active);
      dot.setAttribute('aria-current', active ? 'true' : 'false');
    });
  }

  document.addEventListener('click', (event) => {
    if (!mobileQuery.matches) return;
    const control = event.target.closest('.rp-card-arrow, [data-rp-go]');
    if (control) {
      const card = control.closest(cardSelector);
      if (!card) return;
      event.preventDefault();
      event.stopPropagation();
      const current = Number(card.dataset.rpIndex || 0);
      if (control.matches('.rp-card-prev')) setIndex(card, current - 1);
      else if (control.matches('.rp-card-next')) setIndex(card, current + 1);
      else setIndex(card, Number(control.dataset.rpGo || 0));
      return;
    }

    const link = event.target.closest(`${cardSelector} .gimg-link`);
    if (link) {
      const card = link.closest(cardSelector);
      if (Number(card.dataset.rpSuppressClickUntil || 0) > Date.now()) {
        event.preventDefault();
        event.stopPropagation();
      }
    }
  }, true);

  let gesture = null;
  document.addEventListener('pointerdown', (event) => {
    if (!mobileQuery.matches || event.pointerType === 'mouse') return;
    const link = event.target.closest(`${cardSelector} .gimg-link`);
    if (!link) return;
    event.stopPropagation();
    gesture = {
      card: link.closest(cardSelector),
      pointerId: event.pointerId,
      x: event.clientX,
      y: event.clientY,
      lastX: event.clientX,
      startedAt: performance.now(),
      horizontal: false,
      vertical: false
    };
  }, {passive: true, capture: true});

  document.addEventListener('pointermove', (event) => {
    if (!gesture || gesture.pointerId !== event.pointerId) return;
    const dx = event.clientX - gesture.x;
    const dy = event.clientY - gesture.y;
    gesture.lastX = event.clientX;

    if (!gesture.horizontal && !gesture.vertical) {
      if (Math.max(Math.abs(dx), Math.abs(dy)) < 7) return;
      gesture.horizontal = Math.abs(dx) > Math.abs(dy) * 1.05;
      gesture.vertical = !gesture.horizontal;
    }
    if (!gesture.horizontal) return;

    event.stopPropagation();
    event.preventDefault();
    const card = gesture.card;
    const slides = [...card.querySelectorAll('[data-rp-slide]')];
    const current = Number(card.dataset.rpIndex || 0);
    const atStart = current === 0 && dx > 0;
    const atEnd = current === slides.length - 1 && dx < 0;
    const offset = atStart || atEnd ? dx * .28 : dx;
    const neighbour = current + (dx < 0 ? 1 : -1);
    ensureSlide(slides[neighbour]);
    positionTrack(card, current, offset, false);
    card.dataset.rpSuppressClickUntil = String(Date.now() + 450);
  }, {passive: false, capture: true});

  document.addEventListener('pointerup', (event) => {
    if (!gesture || gesture.pointerId !== event.pointerId) return;
    const card = gesture.card;
    const dx = event.clientX - gesture.x;
    const duration = performance.now() - gesture.startedAt;
    const horizontal = gesture.horizontal;
    if (horizontal) event.stopPropagation();
    gesture = null;
    const current = Number(card.dataset.rpIndex || 0);
    if (!horizontal) {
      positionTrack(card, current);
      return;
    }
    const linkWidth = card.querySelector('.gimg-link')?.clientWidth || 160;
    const commit = Math.abs(dx) >= Math.max(28, linkWidth * .16)
      || (duration < 280 && Math.abs(dx) >= 18);
    setIndex(card, commit ? current + (dx < 0 ? 1 : -1) : current);
  }, {passive: true, capture: true});

  document.addEventListener('pointercancel', (event) => {
    if (gesture) {
      if (gesture.horizontal) event.stopPropagation();
      const current = Number(gesture.card.dataset.rpIndex || 0);
      positionTrack(gesture.card, current);
    }
    gesture = null;
  }, {passive: true, capture: true});

  function initialiseMobileCards() {
    if (!mobileQuery.matches) return;
    document.querySelectorAll(cardSelector).forEach((card) => setIndex(card, 0));
  }

  initialiseMobileCards();
  mobileQuery.addEventListener?.('change', initialiseMobileCards);
})();
